import { IonItem, IonLabel } from "@ionic/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Template } from "../../../@types/template";
import { TemplateQuestion } from "../../../@types/templateQuestion";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const UserTemplateItem = ({ template }: { template: Template }) => {
  const { id }: { id: string } = useParams();
  const [questionsTemplates, setQuestionTemplates] = useState<TemplateQuestion[]>([]);

  const questions = async () => {
    const { data } = await axiosInstance.get(`${api.baseURL}formquestion`, {
      params: {
        populate: false,
        where: {
          form: template.id,
        },
      },
    })
    setQuestionTemplates(data);
  }

  useEffect(() => {
    questions();
  }, []);

  return (
    <IonItem 
    routerLink={questionsTemplates.filter((question) => question.template !== null).length > 0 
      ? `/app/rrhh/usuarios/crear-acuerdos/${id}/${template.id}` : undefined} 
      detail={questionsTemplates.filter((question) => question.template !== null).length > 0 }>
      <IonLabel>
        <h2 style={{ fontWeight: 500 }}>{template.name}</h2>
        <h4>Archivos: {questionsTemplates.length}</h4>
        <h4>Plantillas automáticas: {questionsTemplates.filter((question) => question.template !== null).length}</h4>
      </IonLabel>
    </IonItem>
  );
};
